import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { takeUntil, startWith, map } from 'rxjs/operators';
import { LoaderService } from 'src/app/loader/loader.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';
import { Sale } from '../sales/models/sale';
import { LeadsService } from './leads.service';
import { MotNaoCompra } from 'src/app/settings/models/mot-nao-compra';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss'],
})
export class LeadsComponent implements OnInit {
  env;
  leads: Sale[];

  dash: any; // TODO: tipar
  reasonNotBuy: MotNaoCompra[];
  motsNaoCompra$: Observable<MotNaoCompra[]>;
  leads$: Observable<Sale[]>;

  page = 1;
  pageSize = 10;
  collectionSize = 0;
  filter = new FormControl('');

  private unsubscribe$ = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public leadsService: LeadsService,
    private loaderService: LoaderService,
    public permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      if (this.permissionsService.isPermitted('settings')) {
        this.setInitialFilters();
        this.getLeads(this.env.selected.cnpj);
        this.getDash(this.env.selected.cnpj);
        this.getReasonNotBuy(this.env.selected.cnpj);
      } else {
        this.router.navigateByUrl(`/dash/${params.cnpj}`);
      }
    });
  }

  setInitialFilters() {
    this.leadsService.leadsFilter = {
      appointmentDate: { fromDate: null, toDate: null },
      createdAt: { fromDate: null, toDate: null },
      reasonNotBuyCode: null,
    };
  }

  dateFormat(data: string) {
    if (!data && data === '') {
      return '';
    }

    return moment(data).format('DD/MM/YYYY HH:mm');
  }

  async getReasonNotBuy(cnpj: any) {
    const reasons = await this.leadsService.getReasonNotBuy(cnpj).toPromise();

    this.reasonNotBuy = reasons.filter(item => !item.deleted);
  }
  async getDash(cnpj: any) {
    this.dash = await this.leadsService.getDash(cnpj).toPromise();
  }

  async getLeads(cnpj: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando leads...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.leads = await this.leadsService.getLeads(cnpj).toPromise();

    this.leads$ = this.filter.valueChanges.pipe(
      startWith(''),
      map(text => this.search(text))
    );

    loader.dismiss();
  }

  search(text: string): Sale[] {
    const leadsFiltered: Sale[] = this.leads.filter(lead => {
      const term = text.toLowerCase();
      return (
        lead.titular.nome.toLowerCase().includes(term) ||
        lead.titular.celular.toLowerCase().includes(term) ||
        lead.titular.telefone.toLowerCase().includes(term) ||
        lead.vendedor.nome.toLowerCase().includes(term)
      );
    });

    this.page = 1;
    this.collectionSize = leadsFiltered.length;

    return leadsFiltered;
  }

  async refreshData() {
    await this.getLeads(this.env.selected.cnpj);
    await this.getDash(this.env.selected.cnpj);
  }

  goBack(): void {
    this.router.navigateByUrl(`/salesmodule/${this.env.selected.cnpj}`);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
